import React, { FC } from "react";
import { Control, UseFieldArrayRemove } from "react-hook-form";
import RemoveItem from "app/components/common/buttons/RemoveItem";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";

interface FieldItem {
  id: string;
  dbId?: string;
}
interface Props {
  control: Control<any>;
  errors: any;
  fields: FieldItem[];
  deleteItem: any;
  superannuation: string;
  remove: UseFieldArrayRemove;
  applicantID: string;
  deleteIsPending?: boolean;
}

const DynamicSuperannuation: FC<Props> = ({
  control,
  errors,
  fields,
  superannuation,
  deleteItem,
  applicantID,
  remove,
  deleteIsPending = false,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };
  return (
    <>
      {fields.map((field, index) => {
        const basePath = `${superannuation}.${index}`;
        return (
          <>
            <FormGroup key={field.id} className="relative">
              <InputField
                label={`Name of fund`}
                name={`${basePath}.nameOfFund`}
                control={control}
                type="text"
                required={true}
                placeholder="Mercedes"
                error={
                  getErrorMessage(`${basePath}.nameOfFund`)?.message as string
                }
                className="flex-1"
              />
              <InputField
                label={`Current value`}
                name={`${basePath}.value`}
                control={control}
                type="number"
                required={true}
                placeholder="$20,000"
                error={getErrorMessage(`${basePath}.value`)?.message as string}
                className="flex-1"
                rules={{
                  min: {
                    value: 1,
                    message: "value must be greater than 0",
                  },
                }}
              />
              {index > 0 && (
                <RemoveItem
                  className="absolute right-0"
                  disabled={deleteIsPending}
                  onClick={() => {
                    if (field?.dbId) {
                      deleteItem(
                        `/asset-liability/${applicantID}/superannuation/${field?.dbId}`,
                        {
                          onSuccess: () => {
                            remove(index);
                          },
                        }
                      );
                    } else {
                      remove(index);
                    }
                  }}
                />
              )}
            </FormGroup>
          </>
        );
      })}
    </>
  );
};

export default DynamicSuperannuation;
